import { createFileRoute } from '@tanstack/react-router';

import { AUTH_MODULE_PATHS } from 'shared/common/consts/paths';
import { login } from 'shared/queries/authenticationApi';

import { clientModules } from '@/clientModules';

export const Route = createFileRoute('/redirect')({
  component: RedirectPage
});

function RedirectPage() {
  return <clientModules.authentication.RedirectPage onCallLoginEndpoint={login} paths={AUTH_MODULE_PATHS} />;
}
